// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Notices_tableWrapper__2KtIb","flexibleContainer":"Notices_flexibleContainer__1m4TS"};